import {
  BlockContentValue,
  UnstyledBlockContent
} from "@silversea-ssc/ui-components-react";
import React, { useMemo } from "react";
import { isPresent } from "src/utils/checks";
import { matchesAny } from "src/utils/localization/geolocation";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { Geolocation } from "src/utils/localization/geolocation/geolocation";
import {
  LocationFilterFragment,
  FormDisclaimerFragment
} from "types/graphql-types";

interface DisclaimerMessageProps {
  content: FormDisclaimerFragment | undefined;
}

const DisclaimerMessage: React.FC<
  React.PropsWithChildren<DisclaimerMessageProps>
> = ({ content }) => {
  const geolocation = useGeolocation();

  const disclaimer = useMemo(
    () => toSpecificContent(content, geolocation),
    [content, geolocation]
  );

  if (!disclaimer) return null;

  return (
    <React.Fragment>
      <UnstyledBlockContent value={disclaimer} />
    </React.Fragment>
  );
};

const toSpecificContent = (
  allContents: FormDisclaimerFragment | undefined,
  geolocation: Geolocation
): BlockContentValue | undefined => {
  if (!allContents) return undefined;

  const content = allContents.disclaimer?.localized;

  const overrideContent = allContents.overrideDisclaimer
    ?.map((slide) => {
      const content = slide?.content?.localized;
      if (!content) return undefined;

      return {
        ...slide,
        content
      };
    })
    .filter(isPresent)
    .find(filterByGeolocation(geolocation));

  return overrideContent?.content || content;
};

const filterByGeolocation =
  (geolocation: Geolocation) =>
  (slide: {
    content: BlockContentValue;
    locationFilters?: (LocationFilterFragment | undefined)[];
  }) => {
    const filters = slide.locationFilters;
    if (!isPresent(filters)) return false;

    return matchesAny(filters, geolocation);
  };

export default DisclaimerMessage;
